function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconAmenitiesTelevisionTvFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.937 21h24V7h-24v14zm10 4h4v-2h-4v2zm15-20h-26a1 1 0 00-1 1v16a1 1 0 001 1h9v2h-3v2h14v-2h-3v-2h9a1 1 0 001-1V6a1 1 0 00-1-1z",
    fill: props.color
  }));
}

export default SvgIconAmenitiesTelevisionTvFilled;